"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunkUpdate = void 0;
class ChunkUpdate {
    constructor(chunk, field, size) {
        this.chunk = chunk;
        this.field = field;
        this.size = size;
    }
}
exports.ChunkUpdate = ChunkUpdate;
//# sourceMappingURL=ChunkUpdate.js.map